import { KycProcessStatus, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function isKycSubmitted(kycInfo: KycResponse) {
  return kycInfo.activeProcess?.processStatus === KycProcessStatus.submitted;
}
